import {Component, EventEmitter, forwardRef, Inject, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {MyDateFormat} from "../../../directives/my.date.format";
import {AlertService} from "../../../services/alert.service";
import {DomSanitizer} from "@angular/platform-browser";
import {
    NgbCalendar,
    NgbDate,
    NgbDateParserFormatter,
    NgbDatepickerModule,
    NgbModal
} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";
import * as moment from "moment/moment";
import {Utils} from "../../../model/Utils";
import {NgIf} from "@angular/common";


export type CustomDateRange = {start:Date,end: Date};

@Component({
    selector: 'custom-date-range',
    templateUrl: './custom-date-range.component.html',
    standalone: true,
    imports: [
        NgbDatepickerModule,
        NgIf
    ],
    styles: [`
      .form-group.hidden {
        width: 0;
        margin: 0;
        border: none;
        padding: 0;
      }

      .custom-day {
        text-align: center;
        padding: 0.185rem 0.25rem;
        display: inline-block;
        height: 2rem;
        width: 2rem;
      }

      .custom-day.focused {
        background-color: #e6e6e6;
      }

      .custom-day.range, .custom-day:hover {
        background-color: rgb(2, 117, 216);
        color: white;
      }

      .custom-day.faded {
        background-color: rgba(2, 117, 216, 0.5);
      }
    `]
})

export class CustomDateRangeComponent implements OnChanges {

    @Input() refDate: Date;

    @Input() label = '';

    @Output() onDateUpdate = new EventEmitter<CustomDateRange>();

    @Input() useColClass = true;
    @Input() useLabel = true;

    private _hoveredDate: NgbDate | null = null;

    private _fromDate: NgbDate | null;
    private _toDate: NgbDate | null;


    private _startDate: Date;
    private _endDate: Date;

    private _myDateFormat = new MyDateFormat(this.translateService, this.session);

    constructor(
        @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
        private calendar: NgbCalendar,
        @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
        public formatter: NgbDateParserFormatter,
        @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
        @Inject(forwardRef(() => Router)) private router: Router,
        @Inject(forwardRef(() => SessionService)) private session: SessionService,
        @Inject(forwardRef(() => TranslateService)) private translateService: TranslateService
    ) {
            // this.fromDate = calendar.getToday();
            // this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const res = this._retrieveDates();
        this.onDateUpdate.emit(res);
    }

    private _retrieveDates():CustomDateRange | null {
        if (this.refDate) {
            this._startDate = moment(this.refDate).startOf('month').toDate();
            this._endDate = moment(this.refDate).endOf('month').toDate();

            this._fromDate = Utils.toNgbDate(this._startDate);
            this._toDate = Utils.toNgbDate(this._endDate);

            return {start: this._startDate, end: this._endDate};
        }
        return null;
    }


    get hoveredDate(): NgbDate | null {
        return this._hoveredDate;
    }

    set hoveredDate(value: NgbDate | null) {
        // console.log('Setting hoveredDate ', value);
        this._hoveredDate = value;
    }

    public onClose(){
        // const res = this._retrieveDates();
        console.log('On Close ' + this._startDate + " " + this._endDate);
        if (this._startDate && this._endDate){
            const res = {start: this._startDate, end: this._endDate};
            this.onDateUpdate.emit(res);
        }

    }

    get fromDate(): NgbDate | null {
        return this._fromDate;
    }

    /*

    set fromDate(value: NgbDate | null) {
        console.log('Setting fromDate ', value);
        this._fromDate = value;
    }

    get toDate(): NgbDate | null {
        return this._toDate;
    }

    set toDate(value: NgbDate | null) {
        console.log('Setting toDate ', value);
        this._toDate = value;
    }

     */

    get displayDateRange(){
        // return 'Coucou!';
        if (!this._startDate){
            // console.log('StartDate is null!');
            return '';
        }
        if (!this._endDate){
            // console.log('EndDate is null!');
            return '';
        }
        const start = moment(this._startDate);
        const end = moment(this._endDate);
        if (this.session.isEnglish()){
            if (Utils.sameMonthMoment(start,end)){
                return start.format("MMM") + ' ' + start.format("Do") + ' - ' + end.format("Do") + ' ' + start.format('YYYY');
            }else if (Utils.sameYearMoment(start,end)){
                return start.format("MMM Do") + ' - ' + end.format("MMM Do") + ' ' + start.format('YYYY');
            }else{
                return start.format("MMM Do YYYY") + ' - ' + end.format("MMM Do YYYY");
            }

        }else{
            if (Utils.sameMonthMoment(start,end)){
                return start.format("DD") + ' - ' + end.format("DD") + ' ' + start.format('MMM YYYY');
            }else if (Utils.sameYearMoment(start,end)){
                return start.format("DD MMM") + ' - ' + end.format("DD MMM") + ' ' + start.format('YYYY');
            }else{
                return start.format("DD MMM YYYY") + ' - ' + end.format("DD MMM YYYY");
            }
        }
    }


    onNext(){
        // this.refDate = moment(this.refDate).add(1,'month').toDate();
        // const res = this._retrieveDates();
        // this.onDateUpdate.emit(res);
    }

    onPrevious(){
        // this.refDate = moment(this.refDate).add(-1,'month').toDate();
        // const res = this._retrieveDates();
        // this.onDateUpdate.emit(res);
    }

    //Copied



    onDateSelection(date: NgbDate) {
        // console.log('Enter in Date Selection, ' + this._format(date) + ' from: ' + this._format(this._fromDate) + ' to: ' + this._format(this._toDate));
        if (!this._fromDate && !this._toDate) {
            // console.log('no fromDate ');
            this._fromDate = date;
            this._startDate = Utils.toDate(this._fromDate);
        } else if (this._fromDate && !this._toDate && date && date.after(this._fromDate)) {
            // console.log('with from date, no toDate ' + date.after(this._fromDate));
            this._toDate = date;
            this._endDate = Utils.toDate(this._toDate);
        } else {
            console.log('Other');
            this._toDate = null;
            this._fromDate = date;
            this._endDate = null;
            this._startDate = Utils.toDate(this._fromDate);
        }
        // console.log('Date Selection, ' + this._format(date) + ' from: ' + this._format(this._fromDate) + ' to: ' + this._format(this._toDate));
        // console.log('Date Selection, start: ' + this._startDate + ' end: ' + this._endDate);
        // console.log('Date Selection formatted, start: ' + this._myDateFormat.transform(this._startDate) + ' end: ' + this._myDateFormat.transform(this._endDate));


        // const res = this._retrieveDates();
        // this.onDateUpdate.emit(res);
    }


    private _format(date:NgbDate){
        if (date){
            return date.day + '.' + date.month + '.' + date.year;
        }else{
            return '';
        }
    }

    isHovered(date: NgbDate) {
        return this._fromDate && !this._toDate && this._hoveredDate && date.after(this._fromDate) && date.before(this._hoveredDate);
    }

    isInside(date: NgbDate) {
        return this._toDate && date.after(this._fromDate) && date.before(this._toDate);
    }

    isRange(date: NgbDate) {
        return date.equals(this._fromDate) || (this._toDate && date.equals(this._toDate)) || this.isInside(date) || this.isHovered(date);
    }

    validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
        console.log('CurrentValue ' + currentValue + ' input: ' + input);
        const parsed = this.formatter.parse(input);
        //Utils.toNgbDateStruct()
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }

}